import { UploadPhoto } from 'src/app/pages/os/fechar-os/upload-photo.model';

import { APP_SETTINGS } from "src/environments/environment";
import { Photo } from "../pages/os/fechar-os/photo.model";
import Swal from 'sweetalert2';

export class ImagemUtil {



    public static handleFile(newArrayfiles: File[], files: File[], previewsPhotos: Photo[], isLoadingRegistroFotografico: boolean, addPreviewsPhotos: boolean) {

        if (newArrayfiles.length === 0) {
          return;
        }
    
       
        let msgErroArquivo = '';
        let qtdErrosArquivo = 0;
        let arquivoValido = true;
        var pattern = /image-*/;
    
        for (const f of newArrayfiles) {
    
          if (!f.type.match(pattern)) {
            arquivoValido = false;
            qtdErrosArquivo++;
            msgErroArquivo += `${f.name} - [${f.type}] <br />`;
            msgErroArquivo += "Não é um arquivo de imagem e não foi adicionado";
          }
    
          if (arquivoValido) {
            if (f.name.length > 100) {
              arquivoValido = false;
              qtdErrosArquivo++;
              msgErroArquivo += `${f.name} - [${f.name.length} caracteres] <br />`;
              msgErroArquivo = `O nome do arquivo <br /><br /><span class="fb">${msgErroArquivo}</span><br />que você está tentando inserir é muito longo e não foi adicionado`;
            }
          }
    
          if (arquivoValido) {
    
            const tamanhoArquivo = Number((f.size / 1024 / 1024).toFixed(2));
    
            if (tamanhoArquivo > APP_SETTINGS.tamanhoLimiteUploadArquivo) {
              arquivoValido = false;
              qtdErrosArquivo++;
              msgErroArquivo += `${f.name}  [${tamanhoArquivo}MB] <br />`;
              msgErroArquivo = `O arquivo <br /><br /><span class="fb">${msgErroArquivo}</span><br />que você está tentando inserir ultrapassa o limite de `;
              msgErroArquivo += `<span class="fb">${APP_SETTINGS.tamanhoLimiteUploadArquivo} MB</span> permito para uploads e não foi adicionado.`;
            }
    
          }
    
          if (arquivoValido) {
            
            if (!files.some(file => file.name === f.name)) {
              files.push(f);
    
              if (addPreviewsPhotos) {
                
                isLoadingRegistroFotografico = true;
                const reader = new FileReader();
                reader.onload = (event: any) => {
                  previewsPhotos.push({ dataUrl: event.target.result, name: f.name });
                  isLoadingRegistroFotografico = true;
                };
                reader.readAsDataURL(f);
              }
            }
          }
    
        }
    
        //this.photoForm.get('photo').setValue('');
    
        if (qtdErrosArquivo > 0) {
    
          Swal({
            position: 'center',
            html: msgErroArquivo,
            type: null,
            animation: false,
            customClass: 'animated fadeInDown',
            width: '550px',
            heightAuto: false,
            background: '#f7b924',
            showCloseButton: true,
            showConfirmButton: false,
          });
    
        }
      }





}